import {call, takeLatest} from 'redux-saga/effects';
import Swal from "sweetalert2";
import {actions as contactsActions, types as contactsTypes} from '../Ducks/contacts';

import {callApi} from './utils';
import * as api from '../API/contacts';


function* getContacts(action) {
    const {success, failure} = contactsActions.saga.getContacts;

    yield callApi(
        call(api.getContacts, action.data),
        success,
        failure
    )
}

function* getContactDetails(action) {
    const {success, failure} = contactsActions.saga.getContactDetails;

    yield callApi(
        call(api.getContactDetails, action.data),
        success,
        failure
    )
}

function* getFoodConsiderations(action) {
    const {success, failure} = contactsActions.saga.getFoodConsiderations;

    yield callApi(
        call(api.getFoodConsiderations, action.data),
        success,
        failure
    )
}

function* getPersonMiniProfile(action) {
    const {success, failure} = contactsActions.saga.getPersonMiniProfile;

    yield callApi(
        call(api.getPersonMiniProfile, action.data),
        success,
        failure
    )
}

function* updateContact(action) {
    const {success, failure} = contactsActions.saga.updateContact;

    function* postApiSuccessCallEffect(_res) {
        Swal.fire({
            icon: 'success',
            title: 'Saved successfully!',
            showConfirmButton: false,
            timer: 1500
        })
        yield call(getContactDetails, {...action, data: {id: action.data.id, columns: action.data.columns}});
    }

    yield callApi(
        call(api.updateContact, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getTags() {
    const {success, failure} = contactsActions.saga.getTags;

    yield callApi(
        call(api.getTags),
        success,
        failure
    )
}

function* getPersonFollowUps(action) {
    const {success, failure} = contactsActions.saga.getPersonFollowUps;

    yield callApi(
        call(api.getPersonFollowUps, action.data),
        success,
        failure
    )
}

function* updateFollowUpStatus(action) {
    const {success, failure} = contactsActions.saga.updateFollowUpStatus;
    const {person_id, follow_up_id, ...data} = action.data;

    function* postApiSuccessCallEffect() {
        yield call(getPersonFollowUps, {data: action.data.person_id});
    }

    yield callApi(
        call(api.updateFollowUpStatus, person_id, follow_up_id, data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* deleteFollowUp(action) {
    const {success, failure} = contactsActions.saga.deleteFollowUp;
    const {person_id, follow_up_id} = action.data;

    function* postApiSuccessCallEffect() {
        yield call(getPersonFollowUps, {data: action.data.person_id});
    }

    yield callApi(
        call(api.deleteFollowUp, person_id, follow_up_id),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

export default function* rootCustomerSaga() {
    yield takeLatest(contactsTypes.getContacts, getContacts);
    yield takeLatest(contactsTypes.getContactDetails, getContactDetails);
    yield takeLatest(contactsTypes.getFoodConsiderations, getFoodConsiderations);
    yield takeLatest(contactsTypes.getPersonMiniProfile, getPersonMiniProfile);
    yield takeLatest(contactsTypes.updateContact, updateContact);
    yield takeLatest(contactsTypes.getTags, getTags);
    yield takeLatest(contactsTypes.getPersonFollowUps, getPersonFollowUps);
    yield takeLatest(contactsTypes.updateFollowUpStatus, updateFollowUpStatus);
    yield takeLatest(contactsTypes.deleteFollowUp, deleteFollowUp);
}